// ClosetAdd.jsx
// お気に入りクローゼット: 服を撮影して登録 → AI が品目を判定 → お客様が確認・選び直し（2026-09-24）。
// 写真はアプリで縮小してから送る（長辺2048px・一覧用サムネイル320px）。AI が判定できなくても登録は済み、品目を選んでもらう。
import { IoCameraOutline, IoCloseCircle } from "react-icons/io5";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Post, PostFile } from '../compornents/Post';
import { toast } from 'react-toastify';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { Analytics, Gtag } from '../compornents/Analytics';
import { resizeImage } from '../compornents/closetImage';
import { ItemPicker, ClosetToolbar, FULL_BTN } from './Closet';

const SLOTS = [
  { key: 'whole', label: '服の表', note: '必須・服全体が写るように', required: true },
  { key: 'whole_back', label: '服の裏', note: '任意' },
  { key: 'label_front', label: 'ケアラベル', note: '任意・洗濯表示のタグ' },
];

const PhotoSlot = ({ slot, file, onPick, onClear }) => {
  const ref = useRef(null);
  const [url, setUrl] = useState('');
  useEffect(() => {
    if (!file) { setUrl(''); return undefined; }
    const u = URL.createObjectURL(file);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [file]);
  return (
    <div style={{ border: `1.5px ${file ? 'solid' : 'dashed'} ${file ? '#15803d' : '#b6c6e0'}`, borderRadius: 12, background: file ? '#fff' : '#fbfcff', padding: 8, position: 'relative' }}>
      <div className="div_btn" onClick={() => ref.current && ref.current.click()}
        style={{ height: 120, borderRadius: 8, background: '#f3f4f3', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#5a6166' }}>
        {url ? <img src={url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <IoCameraOutline size={30} />}
      </div>
      {file && <span className="div_btn" onClick={onClear} style={{ position: 'absolute', top: 4, right: 4, color: '#444' }}><IoCloseCircle size={22} /></span>}
      <div style={{ fontSize: 13, fontWeight: 700, marginTop: 6 }}>{slot.label}{slot.required && <span style={{ color: '#dc2626', marginLeft: 4 }}>*</span>}</div>
      <div style={{ fontSize: 11, color: '#5a6166' }}>{slot.note}</div>
      <input ref={ref} type="file" accept="image/*" style={{ display: 'none' }}
        onChange={(e) => { const f = e.target.files && e.target.files[0]; if (f) onPick(f); e.target.value = ''; }} />
    </div>
  );
};

export const ClosetAdd = () => {
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [files, setFiles] = useState({});
  const [itemName, setItemName] = useState('');
  const [consent, setConsent] = useState(false);
  const [result, setResult] = useState(null);   // 登録後: { item, recognize_error }
  const [itemKey, setItemKey] = useState('');
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {});

  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 10);
    (async () => {
      const r = await Post('post', '/closet/index.php', {});
      setInfo(r && r.result === 1 ? r : { enabled: 0 });
    })();
  }, []);

  const enabled = info && Number(info.enabled) === 1;
  // データ活用の同意は、初めて撮影するときにだけ聞く（既定OFF）。あとはクローゼットの画面で変えられる
  const askConsent = enabled && Number(info.consent?.agreed) !== 1 && (info.items || []).length === 0;

  const submit = async () => {
    if (!files.whole) { toast.error('服の表の写真を撮ってください'); return; }
    openLoadingModal();
    try {
      if (askConsent && consent) await Post('post', '/closet/consent.php', { agree: 1 });
      const up = [];
      for (const s of SLOTS) {
        if (files[s.key]) up.push({ key_name: s.key, file: await resizeImage(files[s.key], 2048, 0.85, `${s.key}.jpg`) });
      }
      up.push({ key_name: 'thumb', file: await resizeImage(files.whole, 320, 0.8, 'thumb.jpg') });
      const r = await PostFile('post', '/closet/create.php', { item_name: itemName }, up);
      if (r && r.result === 1) {
        Gtag('closet_add', { recognized: Number(r.recognize_error) === 1 ? 0 : 1, item_key: r.item.item_key });
        setResult(r);
        setItemKey(r.item.item_key || '');
        window.scrollTo(0, 0);
      } else {
        toast.error((r && r.error_message) || '登録できませんでした。もう一度お試しください。');
      }
    } catch (e) {
      toast.error('写真を読み込めませんでした。別の写真でお試しください。');
    }
    closeLoadingModal();
  };

  const confirmItem = async () => {
    if (!itemKey) { toast.error('品目を選んでください'); return; }
    if (itemKey !== result.item.item_key) {
      const r = await Post('post', '/closet/set_item.php', { id: result.item.id, item_key: itemKey });
      if (!r || r.result !== 1) { toast.error('保存できませんでした'); return; }
    }
    toast.success('クローゼットに追加しました');
    navigate('/closet');
  };

  // 登録後: AI の判定を確認してもらう
  if (result) {
    const failed = Number(result.recognize_error) === 1 || !result.item.item_key;
    return (
      <div className="App">
        <div className="Address">
          <Analytics title="クローゼット追加_判定確認" />
          <ClosetToolbar title="品目の確認" />
          <div className="m-4 mb-5 text-left">
            {result.item.thumb_url && <img src={result.item.thumb_url} alt="" style={{ width: 140, height: 140, objectFit: 'cover', borderRadius: 12, border: '1px solid #ddd' }} />}
            <div style={{ fontSize: 14, lineHeight: 1.7, margin: '12px 0' }}>
              {failed
                ? 'AIで品目を判定できませんでした。お手数ですが、品目を選んでください。'
                : <>AIの判定は <b>{result.item.item_label}</b> です。違っていたら選び直してください。</>}
            </div>
            <ItemPicker itemKeys={info.item_keys || []} value={itemKey} onChange={setItemKey} />
            <div style={{ fontSize: 12, color: '#666', marginTop: 10 }}>※料金はお預かり後の検品で確定します。</div>
            <button className="button-next mt-3" style={FULL_BTN} onClick={confirmItem} disabled={!itemKey}>この品目で登録する</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="Address">
        <Analytics title="クローゼット追加" />
        <ClosetToolbar title="服を撮影して追加" onBack={() => navigate('/closet')} />
        <div className="m-4 mb-5 text-left">
          {!info ? <TailSpin stroke="#000" /> : !enabled ? (
            <div style={{ fontSize: 14 }}>お気に入りクローゼットは準備中です。</div>
          ) : (
            <>
              <p style={{ fontSize: 13, lineHeight: 1.7, color: '#444' }}>
                明るい場所で、服を広げて撮ってください。人の顔・住所・名札などが写らないようにお願いします。
              </p>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 14 }}>
                {SLOTS.map((s) => (
                  <PhotoSlot key={s.key} slot={s} file={files[s.key]}
                    onPick={(f) => setFiles((p) => ({ ...p, [s.key]: f }))}
                    onClear={() => setFiles((p) => { const n = { ...p }; delete n[s.key]; return n; })} />
                ))}
              </div>
              <div className="mb-3">
                <div style={{ fontWeight: 700, marginBottom: 4, fontSize: 14 }}>メモ（任意）</div>
                <input className="form-control" maxLength={60} value={itemName} onChange={(e) => setItemName(e.target.value)} placeholder="例）会社用の白シャツ" />
              </div>
              {askConsent && (
                <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12, color: '#444', lineHeight: 1.6, margin: '6px 0 14px' }}>
                  <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} style={{ marginTop: 3 }} />
                  <span>
                    衣類データの活用に協力する（任意）<br />
                    写真と判定結果を、お客様個人がわからない形に加工して、衣類の統計・相場情報や判定精度の改善に使います。あとから変更できます。
                  </span>
                </label>
              )}
              <button className="button-next" style={FULL_BTN} onClick={submit} disabled={!files.whole}>
                {files.whole ? '登録してAIで判定する' : '服の表の写真を撮ってください'}
              </button>
            </>
          )}
        </div>
        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div><TailSpin stroke="#000" /></div>
            <div>写真を送信して、AIで判定しています</div>
            <div style={{ fontSize: 12, color: '#666' }}>10〜20秒ほどかかります</div>
          </div>
        </LoadingModal>
      </div>
    </div>
  );
};
